import { styled } from "@mui/material/styles";
const PatientTodayListContainer = styled("div")`
  height: ${({ heightCSS }) => heightCSS || "100vh"};
`;
const PatientTodayList = styled("div")`
  display: flex;
  flex-direction: column;
`;
const ButtonWrapper = styled("div")`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(1)};
`;
export {
  ButtonWrapper,
  PatientTodayList,
  PatientTodayListContainer
};
